module.exports = __webpack_public_path__ + "img/public/SiteIcons/noTransaction.svg?c8b3e036";